import React from "react";
import { MotifToast } from "@ey-xd/motif-react";
export function ToastMessage({ variant, message, onClose }) {
  return (
    <MotifToast variant={variant} onClose={() => onClose && onClose()} position="top">
      {message}
    </MotifToast>
  );
}
